import dayjs from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl';
import { DatePicker } from 'antd';
import { DateRange } from 'Common/types';

const { RangePicker } = DatePicker;

export type DateRangeProps = {
  dateRange?: DateRange;
  handleDateChange: (range: DateRange) => void;
  disabled?: boolean;
};

const DateRangePicker: React.FC<DateRangeProps> = ({
  dateRange,
  handleDateChange,
  disabled = false,
}) => {
  const intl = useIntl();
  const today = intl.formatMessage({ defaultMessage: 'Today' });
  const lastWeek = intl.formatMessage({ defaultMessage: 'Last 7 days' });
  const thisMonth = intl.formatMessage({ defaultMessage: 'Last month' });

  return (
    <RangePicker
      value={dateRange}
      presets={[
        { label: today, value: [dayjs().startOf('day'), dayjs().endOf('day')] },
        {
          label: lastWeek,
          value: [
            dayjs().subtract(1, 'week').add(1, 'day').startOf('day'),
            dayjs().endOf('day'),
          ],
        },
        {
          label: thisMonth,
          value: [dayjs().startOf('month'), dayjs().endOf('day')],
        },
      ]}
      onChange={(range) =>
        handleDateChange([range?.[0] ?? null, range?.[1]?.endOf('day') ?? null])
      }
      disabled={disabled}
    />
  );
};

export default DateRangePicker;
